const regExpD = /(M|L|(\-?\d+\.?\d*))/gi
const regExpTranslate = /(.*)(translate\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;
const regExpScale = /(.*)(scale\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;


export function read(el, prop, value) {
  let match = null;
  switch (prop) {
    case 'd':
      match = (value || getD(el)).match(regExpD);
      return match ? formatDMatch(match) : null;
    case 'translate':
      match = (value || getTransform(el)).match(regExpTranslate);
      return match ? [+match[3], +match[4]] : null;
    case 'scale':
      match = (value || getTransform(el)).match(regExpScale);
      return match ? [+match[3], +match[4]] : null;
    default:
      return el;
  }
}

export function write(el, prop) {
  switch (prop) {
    case 'd':
      writeD.apply(this, arguments);
      break;
    case 'translate':
      writeTranslate.apply(this, arguments);
      break;
    case 'scale':
      writeScale.apply(this, arguments);
      break;
  }
  return el;
}


function writeD(el) {
  var d = [];
  for (let i = 2; i < arguments.length; i++) {
    d.push((i === 2) ? 'M' : 'L');
    d.push(arguments[i][0]);
    d.push(arguments[i][1]);
  }
  el.setAttribute('d', d.join(' '));
}

function writeTranslate(el) {
  const oldTransform = el.getAttribute('transform');
  let newTransform = null;
  let match = oldTransform ? oldTransform.match(regExpTranslate) : null;
  if (match) {
    newTransform = [
      match[1],
      match[2],
      Math.round(typeof arguments[2] === 'number' ? arguments[2] : +match[3]),
      ',',
      Math.round(typeof arguments[3] === 'number' ? arguments[3] : +match[4]),
      match[5]
    ].join('');
  } else {
    newTransform = [
      oldTransform ? (oldTransform + ' ') : '',
      'translate(',
      Math.round(typeof arguments[2] === 'number' ? arguments[2] : 0),
      ',',
      Math.round(typeof arguments[3] === 'number' ? arguments[3] : 0),
      ')'
    ].join('');
  }
  setTimeout(function () {
    // Firefox bug(?). This was not setting without this timeout.
    el.setAttribute('transform', newTransform);
  }, 1)
  el.setAttribute('transform', newTransform);
}

function writeScale(el) {
  const oldTransform = el.getAttribute('transform');
  let newTransform = null;
  let match = oldTransform ? oldTransform.match(regExpScale) : null;
  if (match) {
    newTransform = [
      match[1],
      match[2],
      typeof arguments[2] === 'number' ? arguments[2] : match[3],
      ',',
      typeof arguments[3] === 'number' ? arguments[3] : match[4],
      match[5]
    ].join('');
  } else {
    newTransform = [
      oldTransform ? (oldTransform + ' ') : '',
      'scale(',
      typeof arguments[2] === 'number' ? arguments[2] : 0,
      ',',
      typeof arguments[3] === 'number' ? arguments[3] : 0,
      ')'
    ].join('');
  }
  el.setAttribute('transform', newTransform);
}

function formatDMatch(match) {
  let points = [];
  let pt = [];
  match.forEach(m => {
    if (m !== 'M' && m !== 'L') {
      pt.push(+m);
      if (pt.length >= 2) {
        points.push([pt[0], pt[1]]);
        pt = [];
      }
    }
  });
  return points;
}

function getD(el) {
  return el.getAttribute('d') || '';
}

function getTransform(el) {
  return el.getAttribute('transform') || '';
}



// WEBPACK FOOTER //
// ./src/chart/inner/transform.js